import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormAdvancedField from "components/form/form-advanced-field";
import { AssetFormTypeProvider } from "pages/asset";
import { AssetDisplay } from "components/thumbnail";
import DialogNewShieldOnEvent from "./dialog-new-shield-on-event";
import AssetSelect from "../../../../../components/select/asset-select";

const LogoAssetForm = ({ customerIdSelected, assetId, asset, handleChange, intl, assetPath, assetIdPath, team }) => {
  const handleAssetChange = useCallback(
    event => {
      const value = event.target.value;
      handleChange(assetIdPath)(value);
    },
    [handleChange, assetIdPath],
  );
  const handleAssetUpload = useCallback(name => ({ base64 }) => handleChange(name)(base64), [handleChange]);

  const [openDialogNewShield, setOpenDialogNewShield] = useState(false);
  const [shieldId, setShieldId] = useState(null);

  useEffect(
    () => {
      setShieldId(assetId || null);
    },
    [assetId],
  );

  const handleClickOpenDialogNewShield = () => {
    setOpenDialogNewShield(true);
  };

  const handleCloseDialogNewShield = () => {
    setOpenDialogNewShield(false);
  };

  return (
    <AssetFormTypeProvider>
      <DataGridItem big>
        <DataGridItem big>
          <AssetSelect
            customerId={customerIdSelected}
            name={assetIdPath}
            label={intl.formatMessage({ id: "common.asset.selectShield" })}
            handleChange={handleAssetChange}
            value={assetId}
            filterCategories={["TEAM_SHIELD"]}
            variables={{
              format: "png",
            }}
          />
        </DataGridItem>
        <DataGridItem big>
          <DialogNewShieldOnEvent
            asset={asset}
            customerIdSelected={customerIdSelected}
            handleChange={handleChange}
            handleAssetUpload={handleAssetUpload}
            intl={intl}
            openDialogNewShield={openDialogNewShield}
            handleCloseDialogNewShield={handleCloseDialogNewShield}
            assetPath={assetPath}
            team={team}
          />
          <FormAdvancedField
            onVisibilityChange={handleClickOpenDialogNewShield}
            label={intl.formatMessage({ id: "app.form.graphicset.asset.new" })}
          />
        </DataGridItem>
        {shieldId && (
          <DataGridItem big>
            <AssetDisplay asset={{ id: shieldId, customerId: customerIdSelected, format: "png" }} width={150} />
          </DataGridItem>
        )}
      </DataGridItem>
    </AssetFormTypeProvider>
  );
};

LogoAssetForm.propTypes = {
  /**
   * Función que se invoca al modificar algún valor
   */
  handleChange: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  asset: PropTypes.object,
  /**
   * Id del asset seleccionado
   */
  assetId: PropTypes.string,
  /**
   * Customer id a utilizar en la query de assets
   */
  customerIdSelected: PropTypes.string,
  /**
   * Path del asset en los datos
   */
  assetPath: PropTypes.string,
  /**
   * Path del assetId en los datos
   */
  assetIdPath: PropTypes.string,
};

export default injectIntl(LogoAssetForm);
